import * as types from '../constants/mutation-types'
import serviceMessage from './messagelistener'
import * as sendData from './senddata'
import { config } from "../utils/globalconfig"

const MAX_RETRY = 10
let retry = 0

var connected = false;
var reconnecting = false
let socket = undefined

var timerID = 0;
var lastPing;
var GOOD_CONNECTION_MS = 5000
var TIMEOUT_THRESHOLD_MS = 10000
var PINGER_INTERVAL_MS = 3000
var CHECKER_INTERVAL_MS = 1000

const pingCheck = function(socket) {
  if (Date.now() - lastPing <= GOOD_CONNECTION_MS) {

  } else if (Date.now() - lastPing <= TIMEOUT_THRESHOLD_MS) {
      console.log('Bad connection or maybe lost connection');

  } else {
    closeWebsocket();
    console.log('lost connection');

    if (reconnecting) {
    }
  }
}

const pinger = function(socket) {
  socket.send('pong');
}

const createWebSocket = function() {
    if (socket !== undefined && socket !== null) {
        socket.close()
        socket = null
    }
    socket = new WebSocket(config.uri)
    socket.binaryType = "arraybuffer"
}

const closeWebsocket = function() {
  connected = false;
  socket.close();
}

const start = function (store) {

  socket.onopen = function () {
    console.log("on open")
    if(timerID){
      clearTimeout(timerID);
      timerID = 0;
    }
    retry = 0
    store.commit(types.SET_CONNECTED, true)
    sendData.sendLogin(store.state.userInfo)
  }

  socket.onclose = function () {
    store.commit(types.SET_CONNECTED, false)
    socket = null
    timerID = setTimeout( () => {
      if (retry < MAX_RETRY) {
        retry++
        console.log("Retry connect websocket: " + retry)
        createWebSocket()
        start(store)
      } else {
        store.commit(types.SET_CONNECT_FAIL, true)
      }
    }, 1000)
    console.log("onclose")
  }

  socket.onerror = function(e) {
    //socket.close()
    console.log("onerror")
  }

  socket.onmessage = function (d) {
    if (d.data instanceof ArrayBuffer) {
      var bytes = new Uint8Array(d.data)
      serviceMessage(bytes, store)
    } else {

    }
  }
}

export { socket }

export function retryConnect (store) {
  retry = 0
  createWebSocket()
  start(store)
  console.log("retryConnect")
}

export default function createWebSocketPlugin() {
  return store => {
    store.subscribe(mutation => {
      switch (mutation.type) {
        case types.RETRY:
          retryConnect (store)
          break
        case types.SET_USER_INFO:
          retryConnect (store)
          break
        case types.SET_OPEN_CHAT:
          if (store.state.userInfo.verified && !store.state.loadInitData) {
            sendData.sendGetRoom()
            store.commit(types.SET_LOAD_INIT_DATA, true)
          }
          break
        case types.SET_STATUS_APP:
          sendData.sendAppStatus(store.state.statusApp)
          break
        case types.SET_USER_ID:
          const userInfo = store.state.userInfo
          if (userInfo.phoneType != null && userInfo.token) {
            sendData.sendAppNotification(userInfo.phoneType, userInfo.deviceId, userInfo.token)
          }
          break
        case types.SET_LIST_ROOM:
          const listRoomIds = store.state.threadIds
          sendData.sendAllHistoryChat(listRoomIds)
          break
      }
    })

  }
}
